import React, { useState, useEffect } from 'react';
import HttpInterceptor from '../../lib/HttpInterceptor';
import { toast } from 'react-toastify';

const ResellerApprovals = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedApp, setSelectedApp] = useState(null);
  const [rejectionReason, setRejectionReason] = useState('');

  useEffect(() => {
    fetchApplications();
  }, []);

  const fetchApplications = async () => {
    try {
      const response = await HttpInterceptor.get('/api/reseller-applications?status=pending');
      setApplications(response.data.data || []);
    } catch (error) {
      toast.error('Failed to load applications');
    } finally {
      setLoading(false);
    }
  };

  const handleApprove = async (id) => {
    try {
      await HttpInterceptor.post(`/api/reseller-applications/${id}/approve`);
      toast.success('Application approved');
      fetchApplications();
    } catch (error) {
      toast.error('Failed to approve application');
    }
  };

  const handleReject = async (id) => {
    if (!rejectionReason.trim()) {
      toast.error('Please provide a rejection reason');
      return;
    }
    try {
      await HttpInterceptor.post(`/api/reseller-applications/${id}/reject`, { rejectionReason });
      toast.success('Application rejected');
      setSelectedApp(null);
      setRejectionReason('');
      fetchApplications();
    } catch (error) {
      toast.error('Failed to reject application');
    }
  };

  return (
    <div className="p-6">
        <h1 className="text-3xl font-bold mb-6">Reseller Applications</h1>

        {loading ? (
          <div className="flex justify-center py-20">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600"></div>
          </div>
        ) : applications.length === 0 ? (
          <p className="text-gray-500 text-center py-20">No pending applications</p>
        ) : (
          <div className="space-y-4">
            {applications.map(app => (
              <div key={app._id} className="bg-white rounded-xl shadow-md p-6">
                <div className="flex justify-between items-start">
                  <div className="flex-1">
                    <h3 className="text-xl font-bold">{app.businessName}</h3>
                    <p className="text-gray-600 mt-2">{app.businessDescription}</p>
                    <div className="mt-4 grid grid-cols-2 gap-4 text-sm">
                      <div>
                        <span className="font-semibold">Business Type:</span> {app.businessType}
                      </div>
                      <div>
                        <span className="font-semibold">Contact:</span> {app.contactEmail}
                      </div>
                      <div>
                        <span className="font-semibold">Phone:</span> {app.contactPhone}
                      </div>
                      <div>
                        <span className="font-semibold">Applied:</span>{' '}
                        {new Date(app.appliedAt).toLocaleDateString()}
                      </div>
                    </div>
                  </div>
                  <div className="flex gap-2 ml-4">
                    <button
                      onClick={() => handleApprove(app._id)}
                      className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                    >
                      Approve
                    </button>
                    <button
                      onClick={() => setSelectedApp(app)}
                      className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                    >
                      Reject
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        {selectedApp && (
          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
            <div className="bg-white rounded-xl shadow-2xl max-w-md w-full p-6">
              <h2 className="text-xl font-bold mb-4">Reject Application</h2>
              <textarea
                value={rejectionReason}
                onChange={(e) => setRejectionReason(e.target.value)}
                placeholder="Enter rejection reason..."
                rows={4}
                className="w-full px-4 py-2 border rounded-lg mb-4"
              />
              <div className="flex gap-4">
                <button
                  onClick={() => handleReject(selectedApp._id)}
                  className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
                >
                  Confirm Reject
                </button>
                <button
                  onClick={() => {
                    setSelectedApp(null);
                    setRejectionReason('');
                  }}
                  className="flex-1 px-4 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
  );
};

export default ResellerApprovals;

